import React, { useState, useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import { Row, Col } from "reactstrap";
import Contact_list from './Dashboard-contact';
import ListingFilter from "./Listingfilter";
const ProfileViewWrapper = (props) => {
  const { activeTab, search, viewId } = props;
  const [filterValueState, setFilterValue] = useState({Speciality:[], Brand:[], Retailer_Profile:[], Company_Origin:[], Annual_Turnover:null });
  const [sort, setSort] = React.useState(true);
  let [searchState, setSearch] = useState(null);

  useEffect(() => {
    if(activeTab)
    handleChangeSelect('search', search);
  }, [search]);
  
  const handleChangeSelect = (input, value)=>{
    console.log('input, value', input, value);
    if(input==='search'){
      searchState=value;
      setSearch(searchState);
      console.log('searchState',searchState);
    }
    if(input==='Speciality'){
      filterValueState.Speciality= value;
    }
    if(input==='Brand'){
      filterValueState.Brand= value;
    }
    if(input==='Retailer_Profile'){
      filterValueState.Retailer_Profile= value;
    }
    if(input==='Company_Origin'){
      filterValueState.Company_Origin= value;
    }
    if(input==='Annual_Turnover'){
      filterValueState.Annual_Turnover= value;
    }
    if(input==='channel_type'){
      filterValueState.typeId= value;
    }
    setFilterValue({ ...filterValueState })
    console.log('filterValueState', filterValueState);
  }
  const resetFilterValue =()=>{
    filterValueState.Speciality=[];
    filterValueState.Brand=[];
    filterValueState.Company_Origin=[];
    filterValueState.Retailer_Profile=[];
    filterValueState.Annual_Turnover=null;
    setFilterValue({ ...filterValueState });
    searchState= null;
    setSearch(searchState);
  }
  return (
        <Card>
          <CardBody>
          <h4 className="text-muted mb-0">FILTERS</h4>
            <Row className="pt-2">
              {/* Left Filter */}
              <Col id="leftFilter" xl="3" lg="4" className="p-0 ml--4">
                {/* <CompanyListingFilters activeTab={activeTab} handleChangeSelect={handleChangeSelect} filterValueState={filterValueState} resetFilterValue={resetFilterValue} /> */}
                <ListingFilter activeTab={activeTab} handleChangeSelect={handleChangeSelect} filterValueState={filterValueState} resetFilterValue={resetFilterValue} viewId={viewId}/>
              </Col>

              <Col style={{ backgroundColor: "#f8f9fe" }} xl="9" lg="8">
                {/* Body */}
                {/* {props.selection ? */}
                {
                    <Contact_list activeTab={activeTab} filterValueState={filterValueState} search ={searchState} viewId={viewId} />                    
                }
               {/* : <Product/>} */}
              
              </Col>
            </Row>
          </CardBody>
        </Card>)
};
export default ProfileViewWrapper;

